<ng-container *ngIf="type === 'default'">
  <div
    *ngIf="showModal"
    class="modal"
    (click)="closeModal()"
    (keydown)="closeModal()"
  >
    <div
      class="modal__content"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      #modalContent
    >
      <div class="modal__content__header">
        <ng-content select=".header-content"></ng-content>
        <div
          class="modal__content__close"
          (click)="closeModal()"
          (keydown)="closeModal()"
        >
          <span>&times;</span>
        </div>
      </div>
      <div class="modal__content__body" #modalContentBody>
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="type === 'video'">
  <div
    *ngIf="showModal"
    class="modal__video"
    (click)="closeModalVideo($event)"
    (keydown)="closeModalVideo($event)"
  >
    <div
      class="modal__video__wrapper"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
    >
      <div class="video-container" #modalContentVideo>
        <div
          class="iframe-wrapper"
          [style.backgroundImage]="'url(' + thumbnailSrc + ')'"
        >
          <iframe
            [src]="videoSrc"
            allow="autoplay; encrypted-media"
            class="modal__content__video"
            allowFullScreen
            title="video"
          ></iframe>
        </div>
        <div class="modal__video__controls">
          <hdi-icon
            class="close__video"
            [iconName]="'close'"
            [color]="color"
            [size]="size"
            (click)="closeModalVideo($event)"
            (keydown)="closeModalVideo($event)"
          ></hdi-icon>
          <hdi-icon
            class="share__video"
            [iconName]="'link'"
            [color]="color"
            [size]="size"
            (click)="shareVideo($event, videoId)"
            (keydown)="shareVideo($event, videoId)"
          ></hdi-icon>
          <span *ngIf="clipboardLabel" class="clipboard-label">
            URL kopiert
          </span>
        </div>
      </div>
    </div>
  </div>
</ng-container>
